import { get } from 'lodash';
import { fetchActivityLogs } from 'api/logs';
import { formatActivityLogs } from 'reducers/log/utils';
import { REQUEST_FAIL } from 'reducers/modal/actions';

export const GET_ACTIVITY_LOG_SUCCESS = 'GET_ACTIVITY_LOG_SUCCESS';

export const getActivityLogs = () => async dispatch => {
  try {
    const response = await fetchActivityLogs();
    const logs = get(response, 'logs', []);
    const formattedLogs = formatActivityLogs(logs);

    // TODO: Only show PUT POST and DELETE

    await dispatch({
      type: GET_ACTIVITY_LOG_SUCCESS,
      data: formattedLogs
    });
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: 'Could not retrieve logs'
    });
    throw err;
  }
};
